import { render, staticRenderFns } from "./ProblemListView.vue?vue&type=template&id=95754fe8&scoped=true&"
import script from "./ProblemListView.vue?vue&type=script&lang=js&"
export * from "./ProblemListView.vue?vue&type=script&lang=js&"
import style0 from "./ProblemListView.vue?vue&type=style&index=0&id=95754fe8&lang=less&scoped=true&"
import style1 from "./ProblemListView.vue?vue&type=style&index=1&id=95754fe8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95754fe8",
  null
  
)

export default component.exports